export const isClientSideResponse = (errorCode: number | null | undefined) =>
	!!errorCode && errorCode >= 400 && errorCode < 500;

export const isServerSideResponse = (errorCode: number | null | undefined) =>
	!!errorCode && errorCode >= 500 && errorCode < 600;
